class InfiniteScrollRemoveData {
  constructor() {
    this.options = {
      infiniteScrollKey: "collection_page_cache",
    };
    const cachedContent = sessionStorage.getItem(
      this.options.infiniteScrollKey,
    );

    if (!cachedContent) return;

    try {
      this.data = JSON.parse(cachedContent);
    } catch (e) {
      sessionStorage.removeItem(this.options.infiniteScrollKey);
      return;
    }

    this.registerEvents();
  }

  registerEvents() {
    const handler = () => {
      if (this.data.path !== window.location.pathname) {
        this.removeFromSession();
      }
    };

    window.addEventListener("beforeunload", handler);
    window.addEventListener("pagehide", handler);
  }

  removeFromSession() {
    sessionStorage.removeItem(this.options.infiniteScrollKey);
  }
}

document.addEventListener(
  "DOMContentLoaded",
  () => new InfiniteScrollRemoveData(),
);
